import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98b4f150")

_pushScopeId("data-v-98b4f150")
const _hoisted_1 = { class: "main-nav" }
const _hoisted_2 = { class: "main-nav__list -bold" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 홈 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 온라인 대면진료 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 2차소견 ")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("ul", _hoisted_2, [
      _createVNode("li", {
        class: _ctx.isActive('/') ? 'main-nav__item -active' : 'main-nav__item'
      }, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.RouterName.HOME }
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"])
      ], 2),
      _hoisted_4,
      _createVNode("li", {
        class: 
          _ctx.isActive('/onlinecare') ? 'main-nav__item -active' : 'main-nav__item'
        
      }, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.RouterName.ONLINE_CARE }
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"])
      ], 2),
      _hoisted_6,
      _createVNode("li", {
        class: 
          _ctx.isActive('/secondopinion')
            ? 'main-nav__item -active'
            : 'main-nav__item'
        
      }, [
        _createVNode(_component_router_link, {
          to: { name: _ctx.RouterName.SECOND_OPINION }
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["to"])
      ], 2),
      _hoisted_8
    ])
  ]))
})